<template>
	<header class="app-header">
		<div class="app-header__logo">
			<header-logo />
		</div>
		<div class="app-header__main">
			<header-access-group-select v-if="showAccessGroup" class="app-header__select" />
			<div class="app-header__rest">
				<header-nav-links class="app-header__nav" />
				<header-notifications-button
					ref="notificationsButtonRef"
					class="app-header__notifications"
				/>
				<header-messages-button
					ref="messagesButtonRef"
					class="app-header__messages"
				/>
				<header-user-dropdown
					@open-notifications="openNotifications"
					@open-messages="openMessages"
				/>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue"
import { useRoute } from "vue-router"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"
import HeaderLogo from "./HeaderLogo.vue"
import HeaderAccessGroupSelect from "./HeaderAccessGroupSelect.vue"
import HeaderNavLinks from "./HeaderNavLinks.vue"
import HeaderNotificationsButton from "./HeaderNotificationsButton.vue"
import HeaderMessagesButton from "./HeaderMessagesButton.vue"
import HeaderUserDropdown from "./HeaderUserDropdown.vue"

const route = useRoute()
const store = headerStore()
const root = rootStore()
const notificationsButtonRef = ref<InstanceType<typeof HeaderNotificationsButton> | null>(null)
const messagesButtonRef = ref<InstanceType<typeof HeaderMessagesButton> | null>(null)

const openNotifications = () => notificationsButtonRef.value?.open()
const openMessages = () => messagesButtonRef.value?.open()

const showAccessGroup = computed(
	() => route.path === '/main' && store.accessGroups.length > 0
)

watch(
	() => root.globalJWT,
	jwt => {
		if (jwt) store.loadAccessGroups()
	},
	{ immediate: true }
)
</script>

<style scoped>
.app-header {
	display: flex;
	align-items: center;
	height: 56px;
	padding: 0 16px;
	background: #4D4D4D;
	color: #fff;
	flex-shrink: 0;

	@media (max-width: 768px) {
    width: 100%;

    /* &__field {
      width: 100%;
    } */
  }
}

.app-header__logo {
	flex: 1;
	display: flex;
	align-items: center;
	min-width: 0;
}

.app-header__main {
	flex: 0 0 80%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
}

.app-header__select {
	flex-shrink: 0;
}

.app-header__rest {
	margin-left: auto;
	display: flex;
	align-items: center;
	gap: 24px;
}


@media (max-width: 768px) {
	.app-header {
		gap: 24px;
		padding: 0 16px;
	}

	.app-header__logo {
		flex: 0 0 80px;
	}

	.app-header__main {
		flex: 1 1 auto;
		min-width: 0;
		gap: 24px;
	}

	.app-header__select {
		flex: 1 1 auto;
		min-width: 0;
		max-width: none;
	}

	/* .app-header__rest {
		flex: 0 0 auto;
		margin-left: 0;
		gap: 0;
	} */

	.app-header__nav,
	.app-header__notifications,
	.app-header__messages {
		display: none;
	}

	.app-header__logo :deep(.svg-icon) {
		width: 86px !important;
		min-width: 86px !important;
		height: 18px !important;
	}
}
</style>
